import React from 'react';
import Uganda_s1 from './uganda_s1';
import Uganda_s1_subjects from './uganda_s1_subjects';
const Uganda_s1cre = () => {
  return (
    <div>
      <Uganda_s1 />
    <Uganda_s1_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Christian Religious Education</h1>
      <h3>Christian in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s1cre